// import "./styles.scss";

import { PanelBody, SelectControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

const BlockSizeOptions = props => {
  const {
    setAttributes
  } = props;

  const {
    size
  } = props.blockAttributes;

  const options = [
    {
      label: "Fit",
      value: "fit"
    },
    {
      label: "Tall",
      value: "tall"
    },
    {
      label: "Full",
      value: "full"
    }
  ];

  return (
    <PanelBody
      className="size-options"
      title={ __('Size') }
    >
      <SelectControl
        value={ size }
        options={ options }
        onChange={ size => setAttributes({ size }) }
      />
    </PanelBody>
  )
}

export default BlockSizeOptions;
